module.exports = __webpack_public_path__ + "static/media/circle1.27cf7880.svg";